import merge from 'lodash/merge';
import { IApiMember } from '../../models/member/member.types';
import {
  IApiPhotoRequest,
  IApiPhotoRequestsResult,
} from '../../models/photoRequests';
import { IApiPhotoPrivacyIncludedArray } from '../../models/photoRequests/photoRequests.types';
import {
  IApiPhotoReveal,
  IApiPhotoRevealsResult,
} from '../../models/photoReveals/photoReveals.types';
import { IApiMainScore } from '../../models/score/score.types';
import { extractPhotoRevealStatus } from '../helper';

export type IApiPhotoPrivacy = Array<IApiPhotoReveal | IApiPhotoRequest>;

const extractRelationshipsFromDataByMemberId = (
  photoReveals: IApiPhotoPrivacy,
  id: string
) =>
  photoReveals.find(
    ({
      relationships: {
        sender: {
          data: { id: senderId },
        },
      },
    }) => senderId === id
  );

const extractOtherInfo = (
  included: IApiPhotoPrivacyIncludedArray,
  photoPrivacyData: IApiPhotoReveal | IApiPhotoRequest | undefined
): {
  score?: number;
  mainPicture?: string | null;
} => {
  if (!photoPrivacyData) return {};

  const {
    relationships: {
      senderMainPicture: { data: mainPicture },
      score: {
        data: { id: scoreId },
      },
    },
  } = photoPrivacyData;

  const memberScore = included.find(
    ({ id, type }: { id: string; type: string }) =>
      type === 'score' && id === scoreId
  ) as IApiMainScore;

  return {
    score: memberScore ? memberScore.attributes.score : undefined,
    mainPicture: mainPicture ? mainPicture.id : null,
  };
};

export const memberInPhotoPrivacySerializer = (coreSerializer: any) => (
  member: IApiMember,
  api: IApiPhotoRevealsResult | IApiPhotoRequestsResult
) => {
  const coreMember = coreSerializer(member, api);
  const reveal = extractRelationshipsFromDataByMemberId(api.data, member.id);

  return merge(coreMember, {
    attributes: { ...extractOtherInfo(api.included, reveal) },
    profile: { ...extractPhotoRevealStatus(api.included, reveal) },
  });
};
